import { render, staticRenderFns } from "./vids-filter.vue?vue&type=template&id=42d0031d&"
import script from "./vids-filter.vue?vue&type=script&lang=js&"
export * from "./vids-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports